import { DesktopApiError } from "@zentrack/desktop-api";

// Re-export the shared DesktopApiError so callers can catch a single error type
// regardless of whether they run against the Electron bridge or the browser
// IndexedDB runtime.
export { DesktopApiError };

export function createError(code: string, message: string) {
  return new DesktopApiError(code, message);
}
